// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.

import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { apiClient } from '../services/api-client.js';
import { useLocale } from '../hooks/useLocale.js';
import { usePageTitle } from '../hooks/usePageTitle.js';

export function ForgotPasswordPage() {
  usePageTitle('Forgot Password');
  const { t } = useLocale();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await apiClient.forgotPassword({ email });
      setSubmitted(true);
    } catch (err: any) {
      setError(err.message || t.common.operation_failed);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-container">
        <h1>{t.auth.forgot_password.title}</h1>

        {submitted ? (
          <div>
            <p className="dm-alert dm-alert--success" role="status">
              {t.auth.forgot_password.success}
            </p>
            <Link to="/login">{t.auth.forgot_password.back_to_login}</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p>{t.auth.forgot_password.subtitle}</p>

            {error && (
              <p className="dm-form-error" role="alert">
                {error}
              </p>
            )}

            <div className="form-group">
              <label htmlFor="email">{t.login.email}</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
                disabled={loading}
              />
            </div>

            <button type="submit" disabled={loading}>
              {loading ? t.auth.forgot_password.sending : t.auth.forgot_password.send}
            </button>

            <p>
              <Link to="/login">{t.auth.forgot_password.back_to_login}</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
